<script setup>
import { useFormField } from './useFormField'
import { GuLabel } from '../label'

/* eslint-disable vue/require-default-prop */
const props = defineProps({
  for: { type: String, required: false },
  asChild: { type: Boolean, required: false },
  as: { type: null, required: false },
  class: { type: null, required: false },
})

const { error, formItemId } = useFormField()
</script>

<template>
  <GuLabel
    :class="[error && 'text-danger', props.class]"
    :for="formItemId"
  >
    <slot />
  </GuLabel>
</template>
